import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ShippingChargeBandReferenceService extends BaseReferenceService {
  constructor() {
    super('ShippingChargeBandReference');
  }
}
